/* eslint-disable import/prefer-default-export */
// /* eslint-disable eqeqeq */
// /* eslint-disable brace-style */
// /* eslint-disable linebreak-style */
// /* eslint-disable import/no-extraneous-dependencies */
// import attachEnterAsClick from 'utils/attachEnterAsClick';

import $ from 'jquery';
import { initDonationAmount, validateDonationAmount, initDonationAmountUpdateAction, initIcon } from '../donation-amount/c-donation-amount';
import { isValidDropdown, isValidText } from '../form-elements/validation';
import scrollTo from '../../js/utils/scroll-to';
import { personalFieldTypes, AddressFieldWithAutocompleteTypes } from '../donation-contact/c-donation-contact';
import initAddressSearch from '../form-elements/google-places';
import { donateSelectCardForm, paymentFieldTypes, getPaymentType } from '../donation-payment/c-donation-payment';
import paymentProcessingScene from '../../js/utils/payment-processing-scene';
import initOrganisationField from '../../components/form-elements/c-organisation';
// import {
//     isValidDropdown, isValidText, isValidEmail, isValidPhone,
//     isValidPostcode, isValidNumber, isValidCcNumber, isValidCvc, isValidBsb,
//     isValidCheckbox, isValidAccountName, isValidCreditCardName
// } from '../../components/form-elements/validation';

const currentPaymentData = {
    currentPaymentType: null,
    currentDonationAmount: null
};

// Common function to handle submit button click on the donate form - it is used on normal
// js-form-validate button and also any button with recaptcha enabled
// Function made global so it can be used by the google recaptcha callback
// window.handleDonateSingleButtonClick = $button => {
window.handleStcDonateButtonClick = $button => {
    const $form = $('.c-stc-donation-form');
    if ($form.length === 0) return;

    if ($button.hasClass('js-click-to-submit')) {
        if (!$button.attr('disabled')) {
            $button.attr('disabled', true);
            $button.removeClass('js-click-to-submit');
            paymentProcessingScene();
        }
    }
};

/* helper: validate all field in personal contact/payment form
* don't put binding here, it called multiple time
* use only when submit or check whole form, not for validate individual field
* mannualy loop and call each field type validation (import from validation.js)
* toggle next button error
*/
export const isValidDetail = (type, fieldTypes, ignoreValidation) => {
    // debug function, set on validateForm();
    if (ignoreValidation === true) {
        /* eslint-disable no-console */
        console.log(`%c Debug mode: %c ${type} validation is ignored\nRemove param true on validateForm() in s-donation-form.js`, 'background: #ccc; color: #ff0000; font-weight: bold', 'background: #ff; color: #333; font-weight: 400');
        return true;
    }

    const $form = $('.c-stc-donation-form');
    if ($form.length === 0) return true;

    let valid = true; // this is the only one who set it true, other will set to false
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const doValidate = (el, func) => {
        if (!func($(el))) valid = false; // make sure it only change to false
    };

    // clear button error
    $buttonWraper.removeClass('Error');

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.jsv-${fieldTypes[i].type} ${fieldTypes[i].tag}:visible`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }

    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

/* helper: validate google autocomplete address detail fields
* toggle next button error
*/
export const isValidAddressDetailWithAutocomplete = (ignoreValidation = false) => {
    // debug function, set on validateForm();
    if (ignoreValidation === true) {
        /* eslint-disable no-console */
        console.log('%c Debug mode: %c google autocomplete validation is ignored\nRemove param true on validateForm() in s-donation-form.js', 'background: #ccc; color: #ff0000; font-weight: bold', 'background: #ff; color: #333; font-weight: 400');
        return true;
    }

    const $form = $('.c-stc-donation-form');
    if ($form.length === 0) return true;

    let valid = true; // this is the only one who set it true, other will set to false
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    // custom callback to toggle address details after form valildation failed.
    const addressCallback = () => {
        const $switchManualBtn = $('.js-search-address-manually a');
        if ($switchManualBtn.length) {
            $switchManualBtn.click();
        }
    };
    const doValidate = (el, func) => {
        if (!func($(el))) {
            valid = false; // make sure it only change to false
            addressCallback();
        }
    };

    // clear button error
    $buttonWraper.removeClass('Error');
    const fieldTypes = AddressFieldWithAutocompleteTypes();
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.jsv-${fieldTypes[i].type} ${fieldTypes[i].tag}:visible`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }

    const streetNameEl = $form.find('.js-address-street input')[0];
    const streetName = (streetNameEl && streetNameEl.value.length > 0) ? streetNameEl.value : false;
    const postcodeEl = $form.find('.js-address-postcode input')[0];
    const postcode = (postcodeEl && postcodeEl.value) ? postcodeEl.value : false;

    if (!!streetName && !!postcode && streetName.includes(postcode)) {
        valid = false;
        $(streetNameEl).closest('.EditingFormValueCell').addClass('js-error invalid');
        addressCallback();
    }

    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

// helper: select which form to validate
export const validateForm = () => {
    if (validateDonationAmount()
        && isValidDetail('personal', personalFieldTypes())
        && isValidAddressDetailWithAutocomplete()
        && isValidDetail('payment', paymentFieldTypes())
    ) {
        return true;
    }
    return false;
};

// init on submit button - only the ones without recaptcha enabled
const initSubmitButton = () => {
    const $form = $('.c-stc-donation-form');
    const $submit = $form.find('.payment-submit-btn').not('.with-recaptcha');

    if ($submit.length === 0) return;

    $submit.click(e => {
        e.preventDefault();
        replaceRightQuotation();
        const $button = $(e.target);
        const currPayType = getPaymentType();
        if (validateForm() && currPayType !== 'cc-form') {
            // window.handleDonateSingleButtonClick($button);
            window.handleStcDonateButtonClick($button);
        }
    });
};

// init on submit button - the ones with recaptcha enabled
const initSubmitButtonWithRecaptcha = () => {
    const $form = $('.c-stc-donation-form');
    const $submit = $form.find('.payment-submit-btn.with-recaptcha');

    if ($submit.length === 0) return;

    $submit.click(e => {
        e.preventDefault();
        replaceRightQuotation();
        const $button = $(e.target);
        const currPayType = getPaymentType();


        if (validateForm() && currPayType !== 'cc-form') {
            const $hiddenToken = $button.siblings('.g-recaptcha-response');
            // we trigger the google recaptcha call for anti-bot measure
            // Only trigger the re-captcha if we havent got the google check token
            if ($hiddenToken.length && $hiddenToken.val()) {
                // console.log($hiddenToken.val());
                window.submitRecaptchaSingleForm($hiddenToken.val());
            } else {
                window.grecaptcha.execute();
            }
        }
    });
};

// replace the right quotation mark with apostrophe
function replaceRightQuotation() {
    const $testFields = $('.c-stc-donation-form input[type=text]');

    $testFields.each(function () {
        if ($(this).val().includes('’')) {
            $(this).val($(this).val().replaceAll('’', "'"));
        }
    });
}

// allow input type number to have maxlength
const initMaxLengthNumber = () => {
    const $numberInput = $('.c-stc-donation-form input[type=number]');
    if (!$numberInput.length) { return; }

    $numberInput.keypress(e => {
        const $el = $(e.target);
        const max = $el.attr('maxlength');
        if (max === undefined || max === '') return true;
        if ($el.val().length >= max) return false;
        return true;
    });
};

// validate input to allow number only on keypress, include money (disallow leading zero)
const initNumberOnlyInput = () => {
    const regex = /^\d*\.?\d{0,2}$/;
    const $numberInput = $('.c-stc-donation-form input[type=number]');
    let oldVal = '';

    if (!$numberInput.length) { return; }

    $numberInput.keypress(e => {
        const $el = $(e.target);
        const event = e || window.event;
        const charCode = (typeof event.which === 'undefined') ? event.keyCode : event.which;
        const charStr = String.fromCharCode(charCode);
        const val = $el.val().toLowerCase() + charStr.toLowerCase();

        // test digit
        if (regex.test(val)) {
            // test for money format, for intro form only
            if ($el.closest('.donate-amount-input').length > 0) {
                if (val.startsWith('0')) return false;
            }

            return true;
        }

        return false;
    });

    // for money (intro form only)
    $numberInput.keyup(e => {
        const $el = $(e.target);
        const newVal = $el.val();

        if ($el.closest('.donate-amount-input').length > 0) {
            if (newVal.startsWith('0')) {
                $el.val(oldVal);
                return;
            }

            oldVal = newVal;
        }
    });
};


/* helper: validate single input base on type
* validate on change
* validate on keyup if it already error
*/
const validateInputByType = ($form, type, validationFunction, callback) => {
    $form.find(`.jsv-${type} input`)
        .on('change', function () { // on change
            validationFunction($(this), callback);
        })
        .keyup(function () { // on keyup only when it has error
            const $el = $(this);
            if ($el.closest('.EditingFormValueCell.js-error').length > 0) validationFunction($el, callback);
        });
};

// Detail form field bind and validation
const initDetailFormUpdateAction = (type, fieldTypes) => {
    const $form = $('.c-stc-donation-form');
    if ($form.length === 0) return;

    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const excludeLoopText = ['dropdown'];

    const toggleButtonError = respon => {
        $buttonWraper.addClass('Error');

        if (respon) {
            if ($form.find(`.${type}-details .js-error`).length === 0) $buttonWraper.removeClass('Error');
        }
    };

    // validate single dropdown on change
    $form.find('.jsv-dropdown select').change(function () {
        isValidDropdown($(this), null, toggleButtonError);
    });
    // dropdown in google autocomplete template use this class.
    $form.find('.jsv-g-autocomplete-dropdown select').change(function () {
        isValidDropdown($(this), null, toggleButtonError);
    });

    // validate input-* [text, phone, number, postcode, cvc, checkbox]
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < fieldTypes.length; i++) {
        if (typeof (fieldTypes[i].func) === 'function' && excludeLoopText.indexOf(fieldTypes[i].type) < 0) {
            validateInputByType($form, fieldTypes[i].type, fieldTypes[i].func, toggleButtonError);
        }
    }
};

const initStcDonationReferrerField = () => {
    const $form = $('.c-stc-donation-form');
    const $referrerDropdown = $form.find('.jsv-referrer select');
    const $otherText = $form.find('.jsv-text-other');

    if (!$referrerDropdown || $otherText) {
        $otherText.slideUp();

        $referrerDropdown.on('change', e => {
            if (e.target.value.toLowerCase() === 'other') {
                $otherText.slideDown('fast');
            } else {
                $otherText.slideUp('fast');
            }

            window.dataLayer.push({
                event: 'referrer_input_change',
                inputId: $(this).attr('id')
            });
        });
    }
};

const initDonationFormMobile = () => {
    const mobileTriggerContainers = document.querySelectorAll('.c-stc-donation-form-mobile-trigger');

    mobileTriggerContainers.forEach(mobileTriggerContainer => {
        const triggerButton = mobileTriggerContainer.querySelector('.c-stc-donation-mobile-trigger-button');
        const donationForm = mobileTriggerContainer.parentElement.querySelector('.c-stc-donation-form');
        if (triggerButton && donationForm) {
            triggerButton.addEventListener('click', () => {
                // const showingDonation = mobileTriggerContainer.classList.contains('showing-mobile-donation');

                // mobileTriggerContainer.classList.toggle('showing-mobile-donation', !showingDonation);
                // donationForm.classList.toggle('show-mobile-donation', !showingDonation);
                mobileTriggerContainer.classList.add('showing-mobile-donation');
                donationForm.classList.add('show-mobile-donation');

                // check if in two columns page
                const twoColumnsSectionAncestor = triggerButton.closest('.two-columns-page-content.has-donation-form');
                const siderbarAncestor = triggerButton.closest('.sidebar-content');
                const mainContentAncestor = triggerButton.closest('.main-content');

                if (twoColumnsSectionAncestor && (siderbarAncestor || mainContentAncestor)) {
                    twoColumnsSectionAncestor.classList.add('showing-mobile-donation');
                    if (siderbarAncestor) {
                        twoColumnsSectionAncestor.classList.add('mobile-donation-sidebar');
                    } else if (mainContentAncestor) {
                        twoColumnsSectionAncestor.classList.add('mobile-donation-main');
                    }
                    // twoColumnsSectionAncestor.classList.add('showing-mobile-donation');
                }

                // donationForm.scrollIntoView(true);
                twoColumnsSectionAncestor.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            });
        }

        const closeButton = mobileTriggerContainer.nextElementSibling;
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                // const showingDonation = mobileTriggerContainer.classList.contains('showing-mobile-donation');

                mobileTriggerContainer.classList.remove('showing-mobile-donation');
                donationForm.classList.remove('show-mobile-donation');

                // check if in two columns page
                const twoColumnsSectionAncestor = triggerButton.closest('.two-columns-page-content.has-donation-form');
                const siderbarAncestor = triggerButton.closest('.sidebar-content');
                const mainContentAncestor = triggerButton.closest('.main-content');

                if (twoColumnsSectionAncestor && (siderbarAncestor || mainContentAncestor)) {
                    twoColumnsSectionAncestor.classList.remove('showing-mobile-donation');
                    if (siderbarAncestor) {
                        twoColumnsSectionAncestor.classList.remove('mobile-donation-sidebar');
                    } else if (mainContentAncestor) {
                        twoColumnsSectionAncestor.classList.remove('mobile-donation-main');
                    }
                    // twoColumnsSectionAncestor.classList.add('showing-mobile-donation');
                }
                twoColumnsSectionAncestor.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            });
        }
    });
    // .c-stc-donation-mobile-close-button
};

const removeKenticoOnclick = () => {
    const $button = $('.c-stc-donation-form .js-form-validate');
    if ($button.length === 0) return;

    if ($button.attr('onclick') !== undefined) {
        $button.addClass('js-click-to-submit');
        $button.removeAttr('onclick');
    }
};

// export const isValidText = ($el, callback) => isFilledText($el, callback);

const initStcFormOrganisationUpdateAction = () => {
    const $orgInputWrap = $('.js-organisation-field');
    if ($orgInputWrap.length === 0) return;

    const $buttonWraper = $('.submit-button-wrapper .EditingFormButtonCell');
    const toggleButtonError = respon => {
        $buttonWraper.addClass('Error');

        if (respon) {
            if ($('.js-error').length === 0) $buttonWraper.removeClass('Error');
        }
    };
    $('.js-organisation-field input')
        .on('change', function () { // on change
            isValidText($(this), toggleButtonError);
            window.dataLayer.push({
                event: `${$(this).attr('type')}_input_change`,
                inputId: $(this).attr('id')
            });
        })
        .keyup(function () { // on keyup only when it has error
            const $el = $(this);
            if ($el.closest('.EditingFormValueCell.js-error').length > 0) isValidText($el, toggleButtonError);
        });
};

$(() => {
    const $donationForm = $('.c-stc-donation-form');

    if (!$donationForm.length) { return; }

    removeKenticoOnclick();

    // init donation on mobile
    initDonationFormMobile();

    // init donation amount on load.
    initDonationAmount();
    // init donation amount and freq on click or on change.
    initDonationAmountUpdateAction(currentPaymentData);
    // init donation message icon
    initIcon();

    // init donation contact detail update action
    initDetailFormUpdateAction('personal', personalFieldTypes()); // on change, click, keyup etc
    initDetailFormUpdateAction('g-autocomplete', AddressFieldWithAutocompleteTypes());
    // init donation payment update action
    initDetailFormUpdateAction('payment', paymentFieldTypes()); // on change, click, keyup etc

    initOrganisationField(initStcFormOrganisationUpdateAction);

    initStcDonationReferrerField();

    initMaxLengthNumber();
    initNumberOnlyInput();
    initAddressSearch();

    donateSelectCardForm(currentPaymentData);
    initSubmitButton();
    initSubmitButtonWithRecaptcha();
});



// WEBPACK FOOTER //
// ./src/components/stc-donation-form/c-stc-donation-form.js